import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliDropdown from '@blibli/blue.dropdown/dist/dropdown/blue/Dropdown'
import BliDropdownTrigger from '@blibli/blue.dropdown/dist/dropdown/blue/DropdownTrigger'
import BliList from '@blibli/blue.lists/dist/lists/blue/List'
import BliLists from '@blibli/blue.lists/dist/lists/blue/Lists'
import BliSearchBar from '@blibli/blue.search-bar/dist/search-bar/blue/SearchBar'
import BliTextField from '@blibli/blue.text-field/dist/text-field/blue/TextField'
import BliIconSiLocation from '@blibli/blue-dls-library-icon/dist/Location'
import BliIconSiPeopleProfile from '@blibli/blue-dls-library-icon/dist/PeopleProfile'
import BliIconSiSearch from '@blibli/blue-dls-library-icon/dist/Search'
import { mapActions, mapState } from 'pinia'

import blueLogo from '@/assets/img/careers-logo-blue.png'
import MouseScroll from '@/components/MouseScroll.vue'
import Breadcrumb from '@/components/nav/Breadcrumb.vue'
import BurgerMenu from '@/components/nav/Burger.vue'
import TopMenu from '@/components/nav/TopMenu.vue'
import { useEmplymentTypeStore } from '@/store/employment-type'
import { useJobStore } from '@/store/job'
import { useLocationStore } from '@/store/location'
import { useMainStore } from '@/store/main'

const BREADCRUMBS = [
  { name: 'Home', link: '/' },
  { name: 'Refer a friend' }
]

const BREADCRUMBS_MOTIVATIONALFIT = [
  { name: 'Home', link: '/' },
  { name: 'Discover your fit' }
]

const BREADCRUMBS_MOTIVATIONAL_FIT_RESULT = [
  { name: 'Home', link: '/' },
  { name: 'Discover Your Fit', link: { path: '/motivational-fit-questions' } },
  { name: 'My Result' }
]

export default {
  name: 'Header',
  components: {
    Breadcrumb,
    BurgerMenu,
    TopMenu,
    MouseScroll,
    BliButton,
    BliList,
    BliLists,
    BliDropdown,
    BliSearchBar,
    BliTextField,
    BliIconSiSearch,
    BliDropdownTrigger,
    BliIconSiPeopleProfile,
    BliIconSiLocation
  },
  data () {
    return {
      searchInput: '',
      departmentName: '',
      autocompleteIsDisplayed: false,
      maskIsShown: false,
      showHeaderTitle: false,
      classes: {
        searchBox: 'search-box',
        flex: 'b-flex',
        mb0: 'mb0'
      },
      selectedExperience: [],
      autocomplete: [],
      posValue: {
        display: '',
        value: [],
        text: 'All Employment Types'
      },
      routeName: '',
      ref: null,
      active: false
    }
  },
  props: ['searchBoxVisibility', 'isSticky'],
  computed: {
    ...mapState(useMainStore, ['isMobile', 'isNavOpen']),
    ...mapState(useJobStore, ['availableFilters']),
    ...mapState(useLocationStore, ['locations']),
    ...mapState(useEmplymentTypeStore, ['employmentTypes']),
    isPositionChanged () {
      return this.posValue.value !== ''
    },
    isDetached () {
      return this.isMobile
    },
    displayLogo () {
      return blueLogo
    },
    breadcrumbs () {
      if (this.routeName === 'ReferralPage') { return BREADCRUMBS } else if (this.routeName === 'MotivationalFit') { return BREADCRUMBS_MOTIVATIONALFIT } else if (this.routeName === 'MotivationalFitResult') { return BREADCRUMBS_MOTIVATIONAL_FIT_RESULT }
    }
  },
  mounted () {
    this.routeName = this.$route.name
    this.searchInput = this.$route.query.title || ''
    this.getAvailableFilters()
    this.getLocations()
    this.getEmploymentTypes()
  },
  methods: {
    ...mapActions(useJobStore, ['getAvailableFilters', 'searchJob']),
    ...mapActions(useLocationStore, ['getLocations']),
    ...mapActions(useEmplymentTypeStore, ['getEmploymentTypes']),
    selectedItemValue (t) {
      this.selectedExperience = t.experience || t.type
      this.posValue.value[0] = t.experience
      this.posValue.value[1] = t.type
    },
    searchJobs () {
      const query_param = { ...this.$route.query }
      query_param.title = this.searchInput
      if ((JSON.stringify(this.$route.query) !== JSON.stringify(query_param))) {
        this.$router.push({ name: 'SearchResult', query: query_param })
        this.closeAutocomplete()
      }
    },
    clearInput () {
      this.searchInput = ''
      if (this.$route.name === 'SearchResult') {
        this.searchJobs()
      }
    },
    closeAutocomplete () {
      this.autocompleteIsDisplayed = this.maskIsShown = false
    },
    bindInput (string, department) {
      if (string && department) {
        this.searchInput = string
        if (department.includes('\n')) {
          this.departmentName = this.formatDepartment(department.split('\n')[1])
        } else {
          this.departmentName = this.formatDepartment(department)
        }
      }
    },
    selectedItem (jobName) {
      this.maskIsShown = false
      this.active = false
      this.searchInput = jobName
    },
    formatDepartment (department) {
      return department.split(' ').join('-').toLowerCase()
    },
    showSearchMask (state) {
      this.maskIsShown = state
      if (!state) {
        this.autocompleteIsDisplayed = false
      }
    },
    displayAutoComplete () {
      this.active = true
      this.autocompleteIsDisplayed = this.maskIsShown = true
    },
    changeAutoComplete () {
      const job_list = this.availableFilters?.jobNames?.length > 0 ? this.availableFilters?.jobNames : ''
      if (job_list && this.searchInput.length > 2) {
        this.autocomplete = job_list.filter(job => job.toLowerCase().includes(this.searchInput.toLowerCase()))
      } else {
        this.autocomplete = []
      }
    }
  },
  watch: {
    'searchInput' () {
      this.changeAutoComplete()
    },
    autocompleteIsDisplayed () {
      if (this.isMobile) {
        this.$emit('updateStickyHeader', this.autocompleteIsDisplayed)
      }
    },
    $route (to) {
      this.routeName = to.name
      this.searchInput = this.$route.query.title || ''
    }
  }
}
